export default __webpack_public_path__ + "cc616e1e0415051001a8c3a82159d232.svg";